interface NumberPadProps {
  onNumber: (value: number) => void;
  onErase: () => void;
  /** How many of each digit are already placed (given + entered). */
  counts: Record<number, number>;
  disabled?: boolean;
}

export function NumberPad({ onNumber, onErase, counts, disabled }: NumberPadProps) {
  return (
    <div className="number-pad">
      {Array.from({ length: 9 }, (_, n) => {
        const digit = n + 1;
        const complete = (counts[digit] ?? 0) >= 9;
        return (
          <button
            key={digit}
            type="button"
            className={`pad-key${complete ? ' complete' : ''}`}
            disabled={disabled || complete}
            onClick={() => onNumber(digit)}
          >
            {digit}
          </button>
        );
      })}
      <button
        type="button"
        className="pad-key erase"
        disabled={disabled}
        onClick={onErase}
        aria-label="Erase"
      >
        ⌫
      </button>
    </div>
  );
}
